module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel2-en-GB@3x-9d22322aeddce0fa7954a90238f11dc1.png";